import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController, NavController } from '@ionic/angular';
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: 'app-generic-notification',
  templateUrl: './generic-notification.component.html',
  styleUrls: ['./generic-notification.component.scss'],
})
export class GenericNotificationModal implements OnInit {
  item: any;

  constructor(
    public params: NavParams,
    public modalController: ModalController,
    protected navCtrl: NavController,
    private utilityService: UtilityService,
  ) {}

  ngOnInit(): void {
    this.item = this.params.get('item');
  }

  buttonClick(action) {
    this.modalController.dismiss().then(() => {
      if (action.internal_link) {
        this.navCtrl.navigateForward(action.internal_link);
      } else if (action.external_link) {
        this.utilityService.openExternalLink(action.external_link, '_system');
      }
    });
  }
}
